import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid2, Stack, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

import { InputSelectField } from 'components/v2/input/InputSelectField';
import { LAYOUT_SPACING } from 'constants/ui/style';
import { useLocalization } from 'localization';
import { useDepartmentMembers } from 'modules/branches/hooks';
import { userStore } from 'stores/userStore';
import { InputMultiSelectField } from 'components/v2/input/InputMultiSelectField';
import { createNewOrderStore } from 'stores/createNewOrderStore';

const CreateOrderWatchers = () => {
  const { t } = useLocalization();
  const { user } = userStore();
  const { formData } = createNewOrderStore();
  const { control, setValue } = useFormContext();
  const { areDepartmentMembersLoading, departmentMembers } = useDepartmentMembers(formData?.branchId);

  const departmentMemberOptions = departmentMembers.map(({ email, fullName }) => ({
    value: email,
    label: fullName,
  }));

  const responsibleUserId = user?.id ?? departmentMembers[0]?.id;
  const defaultUserEmail = departmentMembers.find(({ id }) => id === responsibleUserId)?.email ?? '';

  const selectedResponsibleEmail = formData?.responsibleEmail || defaultUserEmail;
  const selectedWatcherEmails = isEmpty(formData?.watcherEmails) ? [defaultUserEmail] : formData?.watcherEmails;

  useEffect(() => {
    setValue('responsibleEmail', selectedResponsibleEmail);
    setValue('watcherEmails', selectedWatcherEmails);
  }, [areDepartmentMembersLoading]);

  return (
    <Stack gap={LAYOUT_SPACING.FORM.xs}>
      <Grid2 container spacing={LAYOUT_SPACING.FORM.xs}>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <InputSelectField
            name="responsibleEmail"
            control={control}
            options={departmentMemberOptions}
            label="common.terms.responsibleAgent"
            menuHeight={300}
            required
            loading={areDepartmentMembersLoading}
            defaultValue={defaultUserEmail}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <InputMultiSelectField
            name="watcherEmails"
            control={control}
            options={departmentMemberOptions}
            label="orders.pages.new.stepThree.watchersLabel"
            menuHeight={600}
            loading={areDepartmentMembersLoading}
          />
        </Grid2>
      </Grid2>
      <Typography variant="body2" color="text.secondary" sx={{ marginBottom: '1rem' }}>
        {t('orders.pages.new.stepThree.watchersInstructions')}
      </Typography>
    </Stack>
  );
};

export default CreateOrderWatchers;
